import { TruffleSvgGradientId } from "../../Utils";
export const MuiCircularProgress = {
    variants: [
        {
            props: { color: "gradient" },
            style: {
                circle: {
                    stroke: `url(#${TruffleSvgGradientId})`
                }
            }
        }
    ]
};
//# sourceMappingURL=CircularProgress.js.map